import { render, staticRenderFns } from "./passing-away.vue?vue&type=template&id=88ce772c"
import script from "./passing-away.vue?vue&type=script&lang=ts"
export * from "./passing-away.vue?vue&type=script&lang=ts"
import style0 from "./passing-away.vue?vue&type=style&index=0&id=88ce772c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports